import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { GenericError, ProgressBar, Button } from '@egw/components'
import { useState, type FC } from 'react'
import { useTranslation } from '@egw/i18n'
import { ChevronRightIcon } from '@heroicons/react/24/outline'
import { Layout } from '../../../components'

export const WelcomeBackPage: FC = () => {
  const { t } = useTranslation('features-auth')

  // State management setup for future API integration
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)

  // Suppress unused variable warnings for future use
  void setIsLoading
  void setError

  return (
    <Layout>
      {/* Loading initial data to make sure the user has access to this screen and retrieve data based on user enrollment application */}
      {isLoading ? (
        <div className="w-full">
          <SkeletonTheme baseColor="#eeefee" highlightColor="rgba(255, 255, 255, 0.5)">
            <Skeleton count={1} height="100px" className="mb-10" />
            <Skeleton count={5} height="50px" />
          </SkeletonTheme>
        </div>
      ) : null}

      {/* In some cases initial data can be null, so we assume if it's not loading and there's no error - we show the page */}
      {!isLoading && !error ? (
        <div className="w-full flex-1 flex flex-col justify-center items-center mt-3xl">
          <h1 className="text-center text-black font-normal text-5xl leading-[110%] typo-libre-caslon-text-regular mb-2xl">
            {t('re_entry.welcome_back.title', { name: 'John' })}
          </h1>
          <div className="flex w-[356px] p-2xl flex-col justify-center items-start rounded-lg bg-background-surface shadow-md">
            <p className="text-left text-text-body typo-primary-base-regular mb-0">
              {t('re_entry.welcome_back.description_1')}
              <br />
              {t('re_entry.welcome_back.description_2')}
            </p>
            <ProgressBar
              showAnimation
              progressPercentage={3 / 13}
              previousPercentage={2 / 13}
              className="w-full my-md"
              testId="enrollment-progress"
              ariaLabel="Enrollment progress"
            />
            <Button
              variant="primary"
              size="default"
              onClick={() => {
                // Handle continue action - TODO: implement navigation logic
              }}
              testId="continue-application-btn"
              className="w-full"
            >
              <span className="flex items-center justify-center gap-xs text-gray-100">
                <span className="text-sm">{t('re_entry.welcome_back.continue')}</span>
                <ChevronRightIcon className="w-[20px] h-[20px] text-gray-100 flex-shrink-0" />
              </span>
            </Button>
          </div>
        </div>
      ) : null}

      {/* This error handles the case when the initial data is not loaded, for example network error */}
      {error ? (
        <div className="flex-1 flex flex-col justify-start md:justify-center">
          <GenericError errorMessage={t('common.generic_error')} />
        </div>
      ) : null}
    </Layout>
  )
}
